export default __webpack_public_path__ + "static/media/3334 knife block B top.71168f1e.png";